import { CustomerRole } from '@edgebox/data-definitions';
import React, { useContext } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { ApiContext } from '../../../common';
import { AppContext } from '../../../common/contexts/AppContext';
import { FullWidthTabsPageLayout } from '../../Layouts/FullWidthTabsPageLayout';

export function AccountTabsLayout() {
  const api = useContext(ApiContext);
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const customerRoles = api?.currentUser?.customerRoles;
  const canManageUsers = customerRoles?.includes(CustomerRole.Owner);
  const canViewInvoices = customerRoles?.includes(CustomerRole.Owner) || customerRoles?.includes(CustomerRole.ManageFinances);
  const hasCustomer = !!appContext.customer;

  const activeTab = location.pathname.startsWith('/subscriptions')
    ? '/subscriptions'
    : location.pathname.startsWith('/account/users')
      ? '/account/users'
      : location.pathname.startsWith('/account/billing')
        ? '/account/billing'
        : '/account/profile';

  return (
    <FullWidthTabsPageLayout
      size="large"
      tabs={
        <Tabs
          id="account-tabs"
          className={'m-0 ps-2 pe-2 pt-0 pb-0'}
          activeKey={activeTab}
          onSelect={(key) => {
            if (!key) {
              return;
            }
            navigate(`${key}${location.search}`);
          }}
        >
          <Tab eventKey="/account/profile" title={'My account'} />
          {hasCustomer && canViewInvoices ? <Tab eventKey="/subscriptions" title={'Subscriptions'} /> : null}
          {canManageUsers ? <Tab eventKey="/account/users" title={'Users'} /> : null}
          {hasCustomer && canViewInvoices ? <Tab eventKey="/account/billing" title={'Billing'} /> : null}
        </Tabs>
      }
    >
      <Outlet />
    </FullWidthTabsPageLayout>
  );
}
